import { useEffect, useRef, useState } from "react";
import { Handle, Position } from "reactflow";
import { ClusterOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import autoResizeTextarea from "utils/autoResizeTextarea";
import "./TitleIntentNode.scss";
import { useFlowNodes } from "../../context";

const TitleIntentNode = ({ data }) => {
  const { updateIntent, intent } = useFlowNodes();
  const { t } = useTranslation();
  const inputRef = useRef();
  const initialName = intent?.name || "";
  const [intentName, setIntentName] = useState(() => initialName || "");
  const [highlightAddButton, setHighlightAddButton] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setHighlightAddButton(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setIntentName(value);
    updateIntent?.((prev) => ({ ...prev, name: value }));
    autoResizeTextarea(inputRef.current);
  };

  const [showGreenBorder, setShowGreenBorder] = useState(false);

  useEffect(() => {
    setShowGreenBorder(true);
  }, []);

  return (
    <>
      <Handle type="source" id="titleHandle" position={Position.Right} />
      <Handle type="source" id="bottom" position={Position.Bottom} />
      <Handle type="source" id="top" position={Position.Top} />
      <div className="intent-root animated-border" tabIndex={0}>
        <div className="intent-header">
          <div className="intent-title">
            <span className="icon-root-badge">
              <ClusterOutlined />
            </span>
            <span className="title-text">{t("common:intents.name.title")}</span>
          </div>

          <div className="intent-separator" />
        </div>
        <div className="intent-container">
          <textarea
            ref={inputRef}
            className="intent-textarea"
            placeholder={t("common:intents.name.placeholder")}
            value={intentName}
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  );
};

export default TitleIntentNode;
